"use client";

import { TopBar, TopNavBar, Footer } from '@/layout';
import { useParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { accommodationsService } from '@/api/services';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import HotelGallery from './components/HotelGallery';
import AboutHotel from './components/AboutHotel';

const HotelDetail = ({ initialHotel = null, id: idProp = null }) => {
  const { id: idParam } = useParams();
  const id = idProp || idParam;
  const [hotel, setHotel] = useState(initialHotel);
  const [loading, setLoading] = useState(!initialHotel);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (initialHotel) return;
    const fetchHotel = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await accommodationsService.getById(id, { include_wh: 1 });
        // Handle both response formats: {data: {...}} or direct {...}
        const hotelData = response.data?.data || response.data;
        
        setHotel(hotelData);
      } catch (err) {
        setError(err.response?.data?.message || err.message || 'Failed to load hotel');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchHotel();
    }
  }, [id, initialHotel]);

  if (loading) {
    return (
      <>
        <TopBar />
        <TopNavBar />
        <main className="py-5 py-lg-6">
          <Container>
            <Row>
              <Col className="text-center">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading hotel...</span>
                </Spinner>
              </Col>
            </Row>
          </Container>
        </main>
        <Footer />
      </>
    );
  }

  if (error || !hotel) {
    return (
      <>
        <TopBar />
        <TopNavBar />
        <main className="py-5 py-lg-6">
          <Container>
            <Row>
              <Col className="text-center text-danger">
                <p>{error || 'Hotel not found'}</p>
                <p>Please check back later or explore other hotels.</p>
              </Col>
            </Row>
          </Container>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <TopBar />
      <TopNavBar />

      <main>
        <HotelGallery hotel={hotel} />
        <AboutHotel hotel={hotel} />
      </main>

      <Footer />
    </>
  );
};

export default HotelDetail;

